import CityPageTemplate from "../city-template/CityPageTemplate";
import { columbusOhConfig } from "./data";

export default function ColumbusOhPage() {
  return <CityPageTemplate config={columbusOhConfig} />;
}